import { SvgIcon, SvgIconProps } from '@mui/material';

const XIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.46447 6.46449L10 10M10 10L13.5355 13.5356M10 10L6.46447 13.5356M10 10L13.5355 6.46449"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export default XIcon;
